import { module } from 'stereomodularjs';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
        
    }

    init() {
        const el = this.el;
        const button = document.querySelector('.js-button-sticky-header');
        if (window.isProgram) {
            try {
                el.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'click_admission',
                        'page_category': 'Programmes',
                        'departement': programInfos.departement,
                        'cycle': programInfos.cycle,
                        'diplome': programInfos.diplome,
                        'programme_code': programInfos.code,
                        'programme_nom': programInfos.name
                    });
                });
                button.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'click_admission',
                        'page_category': 'Programmes',
                        'departement': programInfos.departement,
                        'cycle': programInfos.cycle,
                        'diplome': programInfos.diplome,
                        'programme_code': programInfos.code,
                        'programme_nom': programInfos.name
                    });
                });
            } catch(e) {}

        }
        // Use GSAP ScrollTrigger to trigger a function when the element's top position is at or beyond 40px
        ScrollTrigger.create({
            //markers: true,
            trigger: el,
            start: 'top 0px', // Starts the trigger 40px from the top of the viewport
            END: 'bottom 0px', // Starts the trigger 40px from the top of the viewport
            onLeave: () => {
                button.classList.add('-is-fixed-top'); // Add the 'highlight' class when the condition is met
                // console.log('onLeave');
            },
            onEnter: () => {
                button.classList.remove('-is-fixed-top'); // Remove the 'highlight' class when scrolling back up
                // console.log('onEnter');
            },
            onEnterBack: () => {
                button.classList.remove('-is-fixed-top'); // Remove the 'highlight' class when scrolling back up
                // console.log('onEnterBack');
            },
        });
    }
}
